import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';

@Component({
  selector: 'app-modal-return-asset',
  templateUrl: './modal-return-asset.component.html',
  styleUrls: []
})
export class ModalReturnAssetComponent implements OnInit {

  conditionTypes: any = [
    { id: 'new', name: 'Nuevo' },
    { id: 'used', name: 'Usado' },
    { id: 'damaged', name: 'Dañado' },
    { id: 'refurbished', name: 'Reacondicionado' },
  ];

  cities: any = [
    { id: 'la_paz', name: 'La Paz' },
    { id: 'santa_cruz', name: 'Santa Cruz' },
  ];

  dataForm: FormGroup = new FormGroup({
    condition: new FormControl('', Validators.required),
    city: new FormControl('', Validators.required),
    notes: new FormControl(''),
  });

  constructor(
    private mService: MainService,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<ModalReturnAssetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void { }

  submitForm(){
    if(this.dataForm.invalid){
      return;
    }

    this.mService.post_request(`assets/${this.data.id}/return`, this.dataForm.value)
    .subscribe((resp: any)=>{
      if(resp.status){
        this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
        this.dialogRef.close(resp.item);
      }else{
        if(resp?.errors?.length > 0){
          resp.errors.forEach((element: any) => {
            this.toast.error(element, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
          });
        }else{
          this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        }
      }
    });
  }

  dismiss(){
    this.dialogRef.close(null);
  }
}
